import { useDownloadActions } from '../DownloadMenu'

// The header's own button opens `DownloadMenu` directly, so the items answer
// to their own ids with nothing in front of them.
export const useDownloadButtonMenu = () => {
  const switcher = useDownloadActions()

  const onClick = (keys: string[]) => switcher.run(keys)

  return { onClick }
}
